import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { useIsMobile, UIDPrefix } from '@amzn/storm-ui';
import { O as OptionsContainer, a as OptionsPartWrapper } from './SentimentScale.styles-fdWAK_KI.js';
import { O as Option } from './Option/Option-CN0ABx5E.js';

function isValueSelected(value, selectedValue) {
  if (!['string', 'number'].includes(typeof selectedValue)) {
    return false;
  }
  return `${value}` === `${selectedValue}`;
}
const getGetOption = ({
  selectedValue,
  disabled: defaultDisabled = false,
  name,
  onChange,
  variant
}) => option => {
  const {
    id,
    value,
    disabled,
    label
  } = option;
  return /*#__PURE__*/React__default.createElement(Option, {
    key: id,
    checked: isValueSelected(value, selectedValue),
    disabled: disabled || defaultDisabled,
    id: id,
    label: label,
    name: name,
    onChange: onChange,
    value: value,
    variant: variant
  });
};
const OptionsGroup = ({
  id,
  variant,
  errorMessage,
  options,
  disabled,
  selectedValue,
  name,
  onChange
}) => {
  const isMobile = useIsMobile();
  const getOption = getGetOption({
    selectedValue,
    disabled,
    name,
    onChange,
    variant
  });
  return /*#__PURE__*/React__default.createElement(UIDPrefix, {
    value: id
  }, /*#__PURE__*/React__default.createElement(OptionsContainer, _extends({
    id: id,
    "aria-labelledby": id,
    $variant: variant
  }, errorMessage ? {
    'aria-invalid': 'true'
  } : {
    'aria-invalid': 'false'
  }), isMobile && variant === 'numeric-10' ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OptionsPartWrapper, null, options.slice(0, 6).map(getOption)), /*#__PURE__*/React__default.createElement(OptionsPartWrapper, {
    $justifyContent: "space-around"
  }, options.slice(6).map(getOption))) : options.map(getOption)));
};

export { OptionsGroup as O };
//# sourceMappingURL=OptionsGroup-UYnE4OFN.js.map
